<template>
  <div class="Sidebar">
    <SidebarSide
      v-if="screenSizes.includes('sm')"
      v-bind="$attrs"
      :activeIndex.sync="activeIndex"
      :links="links"
      v-on="$listeners" />

    <SidebarBurger
      v-else
      v-bind="$attrs"
      :activeIndex.sync="activeIndex"
      :links="links"
      v-on="$listeners" />
  </div>
</template>

<script>

import SidebarBurger from './SidebarBurger'
import SidebarSide from './SidebarSide'
import { getters } from '../../utils'

export default {
  components: {
    SidebarBurger,
    SidebarSide,
  },
  props: {
    links: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      activeIndex: null,
    }
  },
  computed: getters('screenSizes'),
  methods: {
    determineActiveIndex() {
      this.activeIndex = this.links.findIndex(({ to, children = [] }) => {
        const routeName = typeof to === 'object' ? to.name : to
        const matchedRouteNames = [...children.map(({ to }) => to), routeName]
        return this.$route.matched.find(({ name }, matchedIndex) => matchedRouteNames.includes(name))
      })
    },
  },
  created() {
    this.determineActiveIndex()
  },
}
</script>

<style lang="scss">
$_background: $main-dark;
$_background-children: darken($_background, 7%);
$_inactive-opacity: 0.8;

.Sidebar {
  .SidebarSide,
  .SidebarBurger,
  .SidebarBurger nav {
    background: $_background;
  }

  .MenuLink {
    background-color: $_background;
    opacity: $_inactive-opacity;
  }

  .children .MenuLink {
    background-color: $_background-children;
    border-left: 3px solid rgba($white, $_inactive-opacity);
  }
}
</style>
